import { Result, Schema } from 'effect';
import { PositiveIntegerFromString, PositiveNumberFromString, PriceFromString } from '../../../domain/positions';

/**
 * What the text typed into a position's fields reads as, for every row a position is typed into: the row that creates one and the row that edits one.
 *
 * The rules themselves live with the positions they describe, so a row cannot come to allow something the API would refuse. What is here is only the reading of a field's text by them.
 */

const decodeCountable = Schema.decodeResult(PositiveIntegerFromString);

const decodePositionNumber = Schema.decodeResult(PositiveNumberFromString);

const decodePrice = Schema.decodeResult(PriceFromString);

/** The quantity, height or width the text reads as, or null when it reads as none. */
export function toCountable(text: string): number | null {
	return Result.getOrNull(decodeCountable(text));
}

/**
 * The place in the list the text reads as, or null when it reads as none.
 *
 * Not a whole number, unlike a quantity: positions are put between each other, so 1.1 sits between 1 and 2. Below the first place is the one thing it cannot be.
 */
export function toPositionNumber(text: string): number | null {
	return Result.getOrNull(decodePositionNumber(text));
}

/**
 * The price the text reads as, or null when it reads as none.
 *
 * An empty field reads as nought rather than as none: a price is optional, and nothing typed is nothing charged. Unlike a quantity, it need not be whole, and it may be nought.
 */
export function toPrice(text: string): number | null {
	return text === '' ? 0 : Result.getOrNull(decodePrice(text));
}
